interface ContestSnapshot {
  prompt?: string
}

interface ApplicationConfigSnapshot {
  demo_data?: boolean
}

interface LocalEntrySnapshot {
  image_data_url?: string
  is_demo?: boolean
  prompt?: string
  submission_id?: string
}

interface RestoreLocalEntryOptions {
  allowDemo?: boolean
}

export function shouldUseLocalDemoData(
  config: ApplicationConfigSnapshot | null | undefined,
  hostname: string,
): boolean {
  const normalizedHostname = String(hostname || '').toLowerCase()
  return Boolean(config?.demo_data)
    && ['localhost', '127.0.0.1', '::1'].includes(normalizedHostname)
}

export function isRestorableLocalEntry(
  entry: LocalEntrySnapshot | null | undefined,
  contest: ContestSnapshot | null | undefined,
  { allowDemo = false }: RestoreLocalEntryOptions = {},
): boolean {
  if (!entry?.image_data_url || !contest?.prompt || entry.prompt !== contest.prompt) return false
  const isDemo = entry.is_demo || String(entry.submission_id || '').startsWith('local-demo-')
  if (isDemo && !allowDemo) return false
  return true
}
